export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-12.png?48c28ba0639af172a698e5a22005ae81";